import { AppState } from '@Redux/store';
import { Folder, Nullable } from '@Models';

export const getFolderIsLoading = (state: AppState): boolean =>
  state.folder.isLoading;

export const getFolder = (state: AppState): Nullable<Folder> =>
  state.folder.entity ?? null;

export const getArmyListsState = (state: AppState): boolean =>
  state.armyLists.isLoading;
